import React, { useEffect, useRef, useState, useMemo } from "react";
import { Table, Button, Badge } from "react-daisyui";
import { CheckIcon, ExclamationCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import Study from "../../../interfaces/study";
import HighlightTextStudyTable from "./HightlightStudyTable";
import dateConvert from "../../../utils/dateConvert";
interface Props {
  studies: Study[];
  navigateToStudy: (id: number) => void;
  navigateToEditStudy: (id: number) => void;
  filter: string;
  selectedStudies: Set<number>;
  toggleStudySelection: (id: number) => void;
  selectAllStudies: () => void;
  isAllStudiesSelected: boolean;
  onActivateButtonClick: (id: number) => void;
  activateList: number[];
  taskStatuses: any;
  taskPollingStatus: any;
}

const StudyTable: React.FC<Props> = ({
  studies,
  navigateToStudy,
  navigateToEditStudy,
  filter,
  selectedStudies,
  toggleStudySelection,
  selectAllStudies,
  isAllStudiesSelected,
  onActivateButtonClick,
  activateList,
  taskStatuses,
  taskPollingStatus
}) => { 
  const checkErrorStatus = (studyId: any) => {
    console.log(taskPollingStatus[studyId])
    return (taskPollingStatus[studyId] != undefined && taskPollingStatus[studyId] !== '') || taskStatuses[studyId]?.task?.status === 'FAILURE';
}

  const renderButton = (study: Study) => {
    const taskStatus = taskStatuses[study?.id];
    
    const isError = checkErrorStatus(study?.id);
    console.log(isError)
  // Study Failure
  if (isError) {
    return (
      <Button
        color="error"
        size="sm"
        onClick={() => onActivateButtonClick(study.id)}
      >
        <ExclamationTriangleIcon className="h-4 w-4 inline-block mr-1" />
        Error
      </Button>
    );
  }
  
  if(!isError) {
    // Active state from various sources
    if (
      activateList?.includes(study?.id) ||
      study.active ||
      taskStatus?.active
    ) {
      return (
        <Badge color="success" size="lg">
          <CheckIcon className="h-4 w-4"></CheckIcon> active
        </Badge>
      );
    }
  
    // In progress state
    if (
      taskStatus?.created ||
      (study.created && !study.active && !activateList?.includes(study?.id))
    ) {
      return (
        <Button
          color="warning"
          size="sm"
          onClick={() => onActivateButtonClick(study.id)}
        >
          <ExclamationCircleIcon className="h-4 w-4 inline-block mr-1" />
          In progress
        </Button>
      );
    }
  
    // Default state when the study is not active
    if (!study.created && !study.active) {
      return (
        <Button
          color="primary"
          size="sm"
          onClick={() => onActivateButtonClick(study.id)}
        >
          Activate Study
        </Button>
      );
    }
  
    
  }
    // Loading state
    return <p>loading ... </p>;
  };

  return(
  <Table id="study_index_table" className="w-full">
    <Table.Head>
      <span>
        <label>
          <input
            id="study_index_table_select_all_checkbox"
            type="checkbox"
            checked={isAllStudiesSelected}
            onChange={(e) => {
              e.stopPropagation();
              selectAllStudies();
            }}
            className="w-5 h-5 cursor-pointer"
          />
        </label>
      </span>
      <span>ID</span>
      <span>Title</span>
      <span>Created At</span>
      <span>Last Modified</span>
      <span>Active</span>
      <span>Actions</span>
    </Table.Head>

    <Table.Body>
      {studies.map((study: Study) => {
        
        return (
          <Table.Row key={study.title} hover>
            <input
              type="checkbox"
              checked={selectedStudies?.has(study.id)}
              onChange={(e) => {
                e.stopPropagation();
                toggleStudySelection(study.id);
              }}
              className="w-5 h-5 cursor-pointer"
            />
            <span>{study.id}</span>
            <HighlightTextStudyTable text={study.title} highlight={filter} navigateToStudy={() => navigateToStudy(study.id)} />
            <span>{dateConvert(study.created_at)}</span>
            <span>{dateConvert(study.updated_at)}</span>
            <span>
              {renderButton(study)}
            </span>
            <span>
              <a
                onClick={() => navigateToStudy(study.id)}
                className="text-blue-500 link link-hover"
              >
                view
              </a>{" "}
              |{" "}
              <a
                onClick={() => navigateToEditStudy(study.id)}
                className="text-blue-500 link link-hover"
              >
                edit
              </a>
            </span>
          </Table.Row>
        );
      })}
    </Table.Body>

  </Table>
)};

export default StudyTable;
